import { Skeleton } from '@mui/material';
import { useParams } from 'react-router-dom';
import {
	CerebroBreadcrumb,
	CerebroLink,
	CerebroPageContainer,
	CerebroStyledBox,
	CerebroText,
} from '../../shared/components';
import { useSignedNdaQuery } from '../../shared/hooks/Queries';
import { DateUtils } from '../../shared/utils';
import { StandardNda } from '../LenderNda/StandardNda';
import { sanitize } from 'dompurify';

export const Nda: React.FC = () => {
	const { guid } = useParams();

	const signedNdaQuery = useSignedNdaQuery(guid);

	return (
		<CerebroPageContainer>
			<CerebroBreadcrumb>Signed Nda</CerebroBreadcrumb>

			{signedNdaQuery.isLoading && <Skeleton height={600} width={600}></Skeleton>}

			{signedNdaQuery.isError && (
				<CerebroStyledBox>
					<CerebroText sx={{ marginBottom: 2 }}>Unable to access Nda. Please try again later.</CerebroText>
				</CerebroStyledBox>
			)}

			{signedNdaQuery.isSuccess && (
				<>
					<CerebroText>Signed By: {signedNdaQuery.data.acceptedLender}</CerebroText>
					<CerebroText>
						Date: {DateUtils.FormatDateTimeStringWithAmPm(signedNdaQuery.data.acceptedDate.toString())}
					</CerebroText>
				</>
			)}

			{signedNdaQuery.isSuccess && signedNdaQuery.data.ndaType == 'DealSpecific' && (
				<CerebroLink
					sx={{ display: 'block', marginBottom: 2, textAlign: 'right' }}
					href={signedNdaQuery.data.url}
					variant="small"
					target="_blank"
				>
					View Agreement
				</CerebroLink>
			)}

			{signedNdaQuery.isSuccess && signedNdaQuery.data.ndaType == 'Template' && (
				<CerebroText>{signedNdaQuery.data.agreementText}</CerebroText>
			)}

			{signedNdaQuery.isSuccess && signedNdaQuery.data.ndaType == 'BankSpecific' && (
				<CerebroLink
					sx={{ display: 'block', marginBottom: 2, textAlign: 'right' }}
					href={signedNdaQuery.data.url}
					variant="small"
					target="_blank"
				>
					View Agreement
				</CerebroLink>
			)}

			{signedNdaQuery.isSuccess && signedNdaQuery.data.ndaType == 'Custom' && (
				<div dangerouslySetInnerHTML={{ __html: sanitize(signedNdaQuery.data.agreementText ?? '') }}></div>
			)}

			{signedNdaQuery.isSuccess && signedNdaQuery.data.ndaType == 'Standard' && (
				<StandardNda dataRoomGuid={guid} companyName={signedNdaQuery.data.companyName} />
			)}
		</CerebroPageContainer>
	);
};
